import assertNever from "assert-never";
import React from "react";
import { STRINGS } from "../../../strings";
import { PatientVital, PatientVitals } from "../../../system/AppState/AppPatientsState";
import { translate } from "../../../translate";
import {
  FIRE_DUOTONE_ICON,
  GRAPH_DUOTONE_ICON,
  HAPPY_DUOTONE_ICON,
  HEART_DUOTONE_ICON,
} from "../../../utils/svgs_duotone";
import PatientVitalCard from "./PatientVitalCard";

interface Props {
  vitals: PatientVitals;
}

const PatientVitalsCards = (props: Props) => {
  const getReadableValue = React.useCallback((vital: PatientVital | null) => {
    if (vital === null || vital.answer === null) {
      return translate(STRINGS.N_A);
    }

    switch (vital.type) {
      case "bloodPressure":
        return (vital.answer as [string, string]).join(" / ");
      case "bodyTemperature": {
        const temperature = vital.answer as string;
        const unitSymbol = "°F";
        return `${temperature}${unitSymbol}`;
      }
      case "pulseRate":
        return vital.answer as string;
      case "respirationRate":
        return vital.answer as string;
      default:
        assertNever(vital.type);
    }
  }, []);

  return (
    <div className="PatientVitalCards">
      <PatientVitalCard
        icon={GRAPH_DUOTONE_ICON}
        label={translate(STRINGS.BLOOD_PRESSURE)}
        value={getReadableValue(props.vitals.bloodPressure)}
      />

      <PatientVitalCard
        icon={FIRE_DUOTONE_ICON}
        label={translate(STRINGS.TEMPERATURE)}
        value={getReadableValue(props.vitals.bodyTemperature)}
      />

      <PatientVitalCard
        icon={HEART_DUOTONE_ICON}
        label={translate(STRINGS.PULSE)}
        value={getReadableValue(props.vitals.pulseRate)}
      />

      <PatientVitalCard
        icon={HAPPY_DUOTONE_ICON}
        label={translate(STRINGS.RESPIRATION_RATE)}
        value={getReadableValue(props.vitals.respirationRate)}
      />
    </div>
  );
};

export default React.memo(PatientVitalsCards);
